import $ from 'jquery'
// import EmblaCarousel from "embla-carousel";


export default {
    init(){
        $(()=>{

            let $ims = $('.section-home > .embla .slider')
            let count = $ims.length
            let allowClick = true
            if(count > 1){
            //     const embla = EmblaCarousel($(".section-home .viewport")[0], { loop: true, skipSnaps: false });
                // $(".section-home .button-prev").click(()=>{
                //     embla.scrollPrev();
                // })
                // $(".section-home .button-next").click(()=>{
                //     embla.scrollNext();
                // })
                let $imWrap = $('.section-home > .embla');
                $imWrap.data('index',0)
                $ims.eq(0).css({'opacity':1,'zIndex':2});
                $ims.eq(0).find('.info').css({'opacity':1});
                let timee = 500
                $(".section-home .button").click(function(){
                    if(allowClick){
                        allowClick = false
                        let index = $imWrap.data('index') , next = index
                        if($(this).is('.button-next')){
                            next++
                            if(next > count -1){
                                next = 0
                            }
                        }else{
                            next--
                            if(next == 0){
                                next = count -1
                            }
                        }
                        $ims.eq(index).animate({'opacity':0,'zIndex':1},timee)
                        $ims.eq(index).find('.info').animate({'opacity':0},timee/3)
                        setTimeout(()=>{$ims.eq(next).find('.info').animate({'opacity':1},timee/3)},timee*2/3)
                        $ims.eq(next).animate({'opacity':1,'zIndex':2},timee,()=>{
                            $imWrap.data('index',next)
                            allowClick = true
                        })
                    }
                })
                // $(".section-home .button-next").click(()=>{
                    
                // })
            }

            
            
        })
        
    }
}
